import { render, staticRenderFns } from "./activities-order.vue?vue&type=template&id=7d567151&scoped=true&"
import script from "./activities-order.vue?vue&type=script&lang=js&"
export * from "./activities-order.vue?vue&type=script&lang=js&"
import style0 from "./activities-order.vue?vue&type=style&index=0&id=7d567151&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d567151",
  null
  
)

component.options.__file = "activities-order.vue"
export default component.exports